import { FormFieldTypes } from "../../../data/formFieldType";

export const AddCommitteeApprovalFormData = {
  name: "AddCommitteeApprovalFormData",

  initialState: {
    name: '',
    emailAddress: '',
    password: '',
    confirmPassword: ''
  },

  formFields: [
    {
      id: "name",
      lable: "Name",
      Field_Name: "Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "name",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
      },
    },
    {
      id: "emailAddress",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "emailAddress",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
      },
    },
    {
      id: "password",
      lable: "Password",
      Field_Name: "Password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "password",
      fieldSetting: {
        placeholder: "",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
      },
    },
    {
      id: "confirmPassword",
      lable: "Confirm Password",
      Field_Name: "Confirm Password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "confirmPassword",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
      },
    },

  ],
  formSetting: {
    isViewOnly: false,
  },
};

export const viewCommitteeListDataForm = {
  name: "viewCommitteeListDataForm",
  initialState: {
      name: "",
      email:"",
      password:"",
      confirmPassword:""

  },
  formFields: [
      {
          id: "name",
          lable: "Name",
          Field_Name: "Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "name",
          fieldSetting: {
              placeholder: "",
              allowSpace: true,
          },
          style: {
              containerCss: "col-md-6 mb-3",
          },
      },
      {
          id: "email",
          lable: "Email",
          Field_Name: "Email",
          fieldType: FormFieldTypes.INPUT,
          dataField: "email",
          fieldSetting: {
              placeholder: "",
              allowSpace: true,
          },
          style: {
              containerCss: "col-md-6 mb-3",
          },
      },
      {
        id: "password",
        lable: "Password",
        Field_Name: "Password",
        fieldType: FormFieldTypes.PASSWORD,
        dataField: "password",
        fieldSetting: {
          placeholder: "",
        },
        // validation: [{ type: "require" }],
        style: {
          containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
        },
      },
      {
        id: "confirmPassword",
        lable: "Confirm Password",
        Field_Name: "Confirm Password",
        fieldType: FormFieldTypes.PASSWORD,
        dataField: "confirmPassword",
        fieldSetting: {
          placeholder: "",
          allowSpace: true,
        },
        // validation: [{ type: "require" }],
        style: {
          containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
        },
      },

  ],
  formSetting: {
      isViewOnly: false
  }
}